var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "30px",
    height: "30px",
    viewBox: "10 10 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "List/Clients/Gray-YourDocument-750") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 30,
    height: 30,
    rx: 4
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FAFB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 60,
    height: 30,
    rx: 4
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IS-Portal",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "P-Documents",
    transform: "translate(-288.000000, -437.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(288.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 129.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "List/Clients/White-YourDocument-750",
    transform: "translate(0.000000, 150.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button_Download/default"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Button_Download"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Download_Icon",
    transform: "translate(8.250000, 6.750000)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 13.500000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,7.5 L6,0.751615513 C6,0.41432336 6.27273886,0 6.75,0 C7.22726114,0 7.5,0.41432336 7.5,0.751615513 L7.5,7.5 L10.6483713,7.5 C10.9245137,7.5 11.1483713,7.72385763 11.1483713,8 C11.1483713,8.14596244 11.0845899,8.2846372 10.973767,8.3796283 L7.07539569,11.7210894 C6.88815082,11.881585 6.61184918,11.881585 6.42460431,11.7210894 L2.52623302,8.3796283 C2.3165701,8.19991723 2.29228933,7.88426723 2.4720004,7.67460431 C2.5669915,7.56378136 2.70566626,7.5 2.8516287,7.5 L6,7.5 Z",
    id: "Combined-Shape",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.54642932,14.625 C0.24464474,14.625 0,14.3731602 0,14.0625 C0,13.7518398 0.24464474,13.5 0.54642932,13.5 L12.9535707,13.5 C13.2553553,13.5 13.5,13.7518398 13.5,14.0625 C13.5,14.3731602 13.2553553,14.625 12.9535707,14.625 L0.54642932,14.625 Z",
    id: "Line",
    fill: "#4A4A4A",
    fillRule: "nonzero"
  }))))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.771548fcfccacda45b4ebb9af60edf65.svg";
export { ForwardRef as ReactComponent };